import {
  apiGet,
  type ApiRequestOptions,
} from "@softmax/observatory-client/client";
import type { FlagsResponse } from "@softmax/observatory-client/types";
import { flagIsOn, type ObservatoryFlagKey } from "@softmax/web-features/flags";

export async function flagOn({
  key,
  signal,
}: {
  key: ObservatoryFlagKey;
  signal?: AbortSignal | undefined;
}): Promise<boolean> {
  const options: ApiRequestOptions = { elevatedPrivileges: false };

  if (signal !== undefined) options.signal = signal;

  const response = await apiGet<FlagsResponse>("/flags/me", options);
  return flagIsOn({ flags: response.flags, key });
}

export function roomFlagState({
  key,
  signal,
}: {
  key: ObservatoryFlagKey;
  signal?: AbortSignal | undefined;
}): Promise<"enabled" | "disabled" | "unavailable"> {
  return flagOn({ key, signal }).then(
    (enabled) => (enabled ? "enabled" : "disabled"),
    () => {
      signal?.throwIfAborted();
      return "unavailable";
    },
  );
}
